import { useEffect, useState } from "react";
import { useAuthActionType } from "../../../hooks/apis/auth";
import OTPModal from "../otp";
import Register from "../register";
import { useAuthStore } from "../../../store/useUserStore";

function Login(props) {
  const setAuth = useAuthStore((state) => state.setAuth);

  const { data, mutate, isSuccess, isLoading, error, isError } =
    useAuthActionType();

  const [inputError, setInputError] = useState("");
  const [popupOtp, setPopupOtp] = useState(false);
  const [popupRegister, setPopupRegister] = useState(false);

  //Close modal handle
  const handleClose = () => {
    document.querySelector(".loginModal").classList.remove("active");
    document.querySelector(".modal").classList.remove("active");
  };

  //Handle login
  let errors = [];
  const handleLogin = () => {
    const phoneNumber = document.querySelector("#loginPhone").value;
    document.querySelector(".errors").innerHTML = "";

    if (phoneNumber == null || phoneNumber === "") {
      errors.push({ message: "لطفا شماره موبایل خود را وارد کنید" });
    }
    if (isNaN(phoneNumber)) {
      errors.push({
        message: "لطفا شماره موبایل خود را با اعداد انگلیسی وارد کنید.",
      });
    }
    if (
      (phoneNumber.length < 11 &&
        phoneNumber.length > 0 &&
        !isNaN(phoneNumber)) ||
      (phoneNumber.length > 11 && phoneNumber.length > 0 && !isNaN(phoneNumber))
    ) {
      errors.push({
        message:
          "لطفا شماره موبایل خود را به صورت کامل و به همراه ۰ ابتدای آن وارد کنید",
      });
    }

    if (errors.length > 0) {
      //Show errors
      let nodes = errors.map((err) => {
        let p = document.createElement("p");
        p.textContent = err.message;
        return p;
      });
      document.querySelector(".errors").append(...nodes);
    } else {
      //Call API
      mutate({ mobile: phoneNumber });
    }

    errors = [];
  };

  useEffect(() => {
    if (isSuccess) {
      const user_type = data.data.action_type;
      setAuth({ actionType: data.data.action_type });
      if (user_type === "login") {
        //Hide Login modal
        document.querySelector(".loginModal").classList.remove("active");
        document.querySelector(".otp_modal").classList.add("active");
      } else {
        //Hide Login modal
        setAuth({ phoneNumber: document.querySelector("#loginPhone").value });

        document.querySelector(".loginModal").classList.remove("active");
        document.querySelector(".register_modal").classList.add("active");
        setPopupRegister(true);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess]);

  return (
    <>
      <div
        style={{ width: "600px" }}
        className={
          props.showPop ? "popup active loginModal" : "popup loginModal"
        }
      >
        <span
          onClick={handleClose}
          className="close position-absolute"
          style={{ top: "15px", right: "15px", cursor: "pointer" }}
        >
          <svg
            width="28"
            height="28"
            viewBox="0 0 16 16"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill="#676767"
              fillRule="evenodd"
              d="M11.2929,3.29289 C11.6834,2.90237 12.3166,2.90237 12.7071,3.29289 C13.0976,3.68342 13.0976,4.31658 12.7071,4.70711 L9.41421,8 L12.7071,11.2929 C13.0976,11.6834 13.0976,12.3166 12.7071,12.7071 C12.3166,13.0976 11.6834,13.0976 11.2929,12.7071 L8,9.41421 L4.70711,12.7071 C4.31658,13.0976 3.68342,13.0976 3.29289,12.7071 C2.90237,12.3166 2.90237,11.6834 3.29289,11.2929 L6.58579,8 L3.29289,4.70711 C2.90237,4.31658 2.90237,3.68342 3.29289,3.29289 C3.68342,2.90237 4.31658,2.90237 4.70711,3.29289 L8,6.58579 L11.2929,3.29289 Z"
            />
          </svg>
        </span>
        <img
          src="/images/phone-level.svg"
          className="img-fluid mx-auto d-block mb-4"
          width="180"
          style={{ marginTop: "-40px" }}
          alt="phone-level"
        />
        <p className="text-center text-white mb-4" id="title_form">
          لطفا شماره همراه خود را وارد کنید
        </p>
        <p
          style={{ width: "85%" }}
          className="login-phone position-relative m-auto mb-5 d-flex align-items-center justify-content-between"
        >
          <input
            className="w-75 border border-secondary rounded text-white"
            type="text"
            name="loginPhone"
            id="loginPhone"
            placeholder="برای مثال : ۰۹۱۸۱۲۳۴۵۶۷"
            style={{
              background: "#454545",
              padding: "0 40px 0 10px",
              outline: "0",
              letterSpacing: "3px",
              fontSize: "15px",
            }}
          />
          <input
            onClick={handleLogin}
            className="rounded text-white"
            style={{
              width: "24%",
              border: "1px solid #ed1c24",
              background: "#ed1c24",
            }}
            type="button"
            name="loginSubmit"
            id="loginSubmit"
            value="ورود"
          />
          <span
            className="position-absolute text-white d-flex align-items-center justify-content-center rounded"
            style={{
              background: "#ed1c24",
              right: "-10px",
              top: "-4px",
              width: "40px",
              height: "40px",
              fontSize: "20px",
            }}
          >
            <i className="fas fa-phone"></i>
          </span>
        </p>
        <div
          className="errors text-center text-warning position-absolute bottom-0 m-auto"
          style={{ width: "93%" }}
        >
          {inputError}
        </div>
        <div className={isLoading ? "active loading" : "loading"}>
          <img src="/images/loading.svg" className="img-fluid" alt="loading" />
        </div>
      </div>
      <OTPModal showPop={popupOtp} />
      <Register showPop={popupRegister} />
    </>
  );
}

export default Login;
